import { Reveal, ChapterHead } from "./Reveal";
import { useContent } from "@/content";

const SUBJECTS = [
  "SOCIAL MEDIA", "TECHNOLOGY", "AMERICAN CULTURE", "RACE", "CAPITALISM",
  "EDUCATION", "INSTITUTIONS", "ATTENTION", "IDENTITY", "GENERATIONAL BEHAVIOR",
  "CREATIVITY", "CONTRADICTIONS",
];

export const Commentary = () => {
  const c = useContent();

  return (
    <section id="commentary" className="px-6 sm:px-12 lg:px-20 py-24 sm:py-32 max-w-7xl mx-auto" data-testid="commentary-section">
      <ChapterHead index="CHAPTER 03" title="SOCIAL COMMENTARY" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-tight leading-tight">
              {c.commentary_headline || "Watching society function. Identifying patterns. Questioning what everyone else treats as normal."}
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-base sm:text-lg font-light leading-relaxed text-neutral-300 mt-8 max-w-2xl">
              {c.commentary_text || "This work does not claim to possess every answer. It begins by observing the world as it is — the systems, behaviors, technologies, and expectations that surround a generation — and asking why they are treated as inevitable. Arguments are built in public. Perspectives are documented as they develop."}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <blockquote className="border-l-2 border-white pl-6 mt-10" data-testid="commentary-callout">
              <p className="font-display text-lg sm:text-xl font-bold uppercase tracking-tight leading-snug">
                {c.commentary_callout || "“These are not final answers. This is a record of someone learning how to ask better questions.”"}
              </p>
            </blockquote>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <p className="font-meta text-xs tracking-[0.3em] text-neutral-500 mb-6">UNDER OBSERVATION</p>
            <div className="flex flex-wrap gap-2">
              {SUBJECTS.map((s) => (
                <span
                  key={s}
                  className="font-meta text-[10px] sm:text-xs tracking-[0.2em] border border-white/15 px-3 py-2 text-neutral-300 hover:bg-white hover:text-black transition-colors duration-300 cursor-default"
                >
                  {s}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
